export const LOGIN_INCORRECT_MESSAGE = 'Something went wrong. Please try again.';
export const EMAIL_INVALID_MESSAGE = 'Enter valid email.';
export const REPEAT_INVALID_MESSAGE = `Password doesn't match.`;
export const USERNAME_INVALID_MESSAGE = 'Username has to be at least 3 charcters long.';
export const CHANGE_REQUETS_MESSAGE = 'Request password change. Email with link will be delivered to user.';
export const RESET_TO_DEFAULT_MESSAGE = `Reset all account settings to Partner default settings. This can't be undone.`;
export const DELETE_ACCOUNT_TITLE = 'Are you sure you want to delete this account?';
export const DELETE_ACCOUNT_MESSAGE =
	'This action cannot be undone. All data associated with this user account will be permanently deleted.';
export const ADD_EMAIL_REPORT = 'Add automated E-Mail reports';
export const DELETE_ACCOUNTS_TITLE = 'Are you sure you want to delete these accounts?';
export const DELETE_ACCOUNTS_MESSAGE =
	'This action cannot be undone. All data associated with these user accounts will be permanently deleted.';
export const ADD_PERMISSIONS_TITLE = 'Are you sure you want to add permissions?';
export const REMOVE_PERMISSIONS_TITLE = 'Are you sure you want to remove permissions?';
export const CHANGE_PERMISSIONS_MESSAGE = 'This action will also change role to Custom for all selected users.';
export const ROLE_UPDATE_MESSAGE = 'Changing permissions for this user will change role to Custom';
export const COPY_PERMISSIONS_TITLE = 'Copy permissions from another user';
export const COPY_PERMISSIONS_MESSAGE =
	'Please choose user to copy permissions from. After copying, permissions can be customized additionaly.';
export const CHANGE_PASSWORD_TITLE = 'Are you sure you want to change password?';
export const RESET_PASSWORD_TITLE = 'Are you sure you want to reset password?';
export const RESET_PASSWORD_MESSAGE =
	'If you proceed with this action, you will be logged out and your current password will be annulled. You will get an email with further instructions for setting up a new password.';
export const NO_USER_MESSAGE = 'This user does not exist';
export const NOT_AUTH_MESSAGE = 'You don’t have permission to view this page';

export const FORGOT_EXPLANATION =
	'Please enter your email and two step code. If you do not have two-step verification set up, please contact support to have your password reset.';
